import { render, staticRenderFns } from "./BasicSelect.vue?vue&type=template&id=32921e34&scoped=true&"
import script from "./BasicSelect.vue?vue&type=script&lang=js&"
export * from "./BasicSelect.vue?vue&type=script&lang=js&"
import style0 from "./BasicSelect.vue?vue&type=style&index=0&id=32921e34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32921e34",
  null
  
)

export default component.exports